import { useEffect, useState } from "react";
import { Copy, Check, Sparkles } from "lucide-react";
import { toast } from "sonner";
import { api, formatINR } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function Offers() {
  const [coupons, setCoupons] = useState([]);
  const [copied, setCopied] = useState(null);

  useEffect(() => { api.get("/coupons").then(({ data }) => setCoupons(data)); }, []);

  const copy = (code) => {
    navigator.clipboard.writeText(code);
    setCopied(code);
    toast.success(`Copied ${code} · use at checkout`);
    setTimeout(() => setCopied(null), 1800);
  };

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="text-center mb-10 fade-up">
        <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-candle-terracotta mb-3">
          <Sparkles className="w-3 h-3" /> Special Deals
        </div>
        <h1 className="font-serif text-4xl sm:text-5xl">Warm Deals & Little Discounts</h1>
        <p className="text-muted-foreground mt-3 max-w-lg mx-auto">Copy a code, apply at checkout, and let the glow save you a little more.</p>
      </div>

      <div className="grid sm:grid-cols-2 gap-4 sm:gap-6">
        {coupons.map((c) => (
          <div key={c.code} data-testid={`offer-card-${c.code}`}
            className="relative p-6 sm:p-8 rounded-2xl bg-gradient-to-br from-candle-cream via-candle-ivory to-white border border-candle-caramel/30 candle-card">
            <div className="absolute top-4 right-4 text-xs uppercase tracking-widest text-candle-terracotta font-medium">
              {c.type === "percent" ? `${c.value}% OFF` : `${formatINR(c.value)} OFF`}
            </div>
            <div className="font-mono text-2xl sm:text-3xl tracking-wider text-candle-espresso mb-2">{c.code}</div>
            <p className="text-sm text-muted-foreground mb-4">{c.description}</p>
            {c.minOrder > 0 && <div className="text-xs text-muted-foreground mb-4">Min. order: {formatINR(c.minOrder)}</div>}
            <Button data-testid={`offer-copy-${c.code}`} variant="outline" onClick={() => copy(c.code)}
              className="rounded-full border-candle-terracotta text-candle-terracotta hover:bg-candle-terracotta hover:text-white">
              {copied === c.code ? <><Check className="w-4 h-4 mr-1" /> Copied</> : <><Copy className="w-4 h-4 mr-1" /> Copy Code</>}
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
